import type { FunctionComponent } from "react";

import { config } from "shared/data";

import { Container, StyledLogoFlag, SupportButton, Text } from "./styles";

export type Props = {
  className?: string;
};

export const HomeV2Subscription: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <StyledLogoFlag />
    <Text>Help preserve 120 years of quality journalism.</Text>
    <SupportButton anchorProps={{ target: "_blank" }} pathname={config.rosetta.subscribeHost}>
      SUPPORT NOW
    </SupportButton>
  </Container>
);

HomeV2Subscription.displayName = "HomeV2Subscription";
